import React, { useEffect } from "react";
import {
  RoundedTab,
  RoundedTabsContainer,
  TabContent,
} from "./styles/roundedtabs";
import { useTranslation } from "react-i18next";

function RoundedTabs({ tabs, selectedTab, setSelectedTab = () => {} }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!tabs.find((tab) => tab.id === selectedTab)) {
      setSelectedTab(tabs[0].id);
    }
  }, [tabs]);

  return (
    <RoundedTabsContainer>
      {tabs.map((tab, index) => (
        <RoundedTab
          key={tab.id}
          isSelected={tab.id === selectedTab}
          onClick={() => setSelectedTab(tab.id)}
        >
          <TabContent isSelected={tab.id === selectedTab}>
            {tab.i18n ? t(tab.i18n) : tab.label}
          </TabContent>
        </RoundedTab>
      ))}
    </RoundedTabsContainer>
  );
}

export default RoundedTabs;
